// extracted by mini-css-extract-plugin
module.exports = {"courseContent":"styles_courseContent__zbFvZ","sections":"styles_sections__8BR4b"};